import {keyframes} from "@mui/material";

export const spinTransform = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`